import * as types from './mutation-types.js'
import * as helpers from './mutation-helpers'

const mutations = {
  // PODCAST_DOWNLOADS
  [types.REQUEST_PODCAST_DOWNLOADS] (state, { podcastId, options }) {
    const requestInfo = {
      type: types.REQUEST_PODCAST_DOWNLOADS,
      podcastId,
      options
    }
    helpers.addFetching(state, requestInfo)
  },
  [types.SET_PODCAST_DOWNLOADS] (state, { podcastId, options, response }) {
    const requestInfo = {
      type: types.REQUEST_PODCAST_DOWNLOADS,
      podcastId,
      options
    }
    helpers.removeFetching(state, requestInfo)
    helpers.removeMatchingErrors(state, requestInfo)
    helpers.setPodcastDownloads(state, requestInfo, response)
  },
  [types.SET_PODCAST_DOWNLOADS_ERROR] (state, { podcastId, options, error }) {
    const requestInfo = {
      type: types.REQUEST_PODCAST_DOWNLOADS,
      podcastId,
      options
    }
    helpers.removeFetching(state, requestInfo)
    helpers.addError(state, { ...requestInfo, error })
  },

  // EPISODE_DOWNLOADS
  [types.REQUEST_EPISODE_DOWNLOADS] (state, { episodeId, options }) {
    const requestInfo = {
      type: types.REQUEST_EPISODE_DOWNLOADS,
      episodeId,
      options
    }
    state = helpers.addFetching(state, requestInfo)
  },
  [types.SET_EPISODE_DOWNLOADS] (state, { episodeId, options, response }) {
    const requestInfo = {
      type: types.REQUEST_EPISODE_DOWNLOADS,
      episodeId,
      options
    }
    helpers.removeFetching(state, requestInfo)
    helpers.removeMatchingErrors(state, requestInfo)
    helpers.setEpisodeDownloads(state, requestInfo, response)
  },
  [types.SET_EPISODE_DOWNLOADS_ERROR] (state, { episodeId, options, error }) {
    const requestInfo = {
      type: types.REQUEST_EPISODE_DOWNLOADS,
      episodeId,
      options
    }
    helpers.removeFetching(state, requestInfo)
    helpers.addError(state, { ...requestInfo, error })
  }
}

export default mutations
